<div class="background">
  <div class="form-container">
    <h2 class="form-header header">{{rrvconfig?.header?.value}}</h2>
    <form [formGroup]="form"  *ngIf="fields" class="form-body">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      <button mat-raised-button class="button-right function-buttons"   (click)="backtolist()">
        <mat-icon>cancel</mat-icon> Cancel
      </button>&nbsp;
      <button mat-raised-button class="button-right add-button"   *ngIf="this.rrvconfig.mode=='create'" (click)="onSubmit(model)" >
        <mat-icon>send</mat-icon> Submit
      </button>
      <button mat-raised-button class="button-right add-button"   *ngIf="this.rrvconfig.mode=='update'" (click)="onUpdate(model)" >
        <mat-icon>edit</mat-icon> Update
      </button>
    </form>
  </div>
</div>
